import React, { useEffect, useState } from "react";
import { StyleSheet, Image, View, Dimensions, TouchableOpacity } from "react-native";
import { CheckImageType } from "../../../enums/check";
import { typography, Text, theme as themeUiComponent, Icon } from "ui-components";
import automationTestingLocators from "../../../screens/new/utils/automation-testing-locators.json";
import { translate } from "../../../i18n/translate";
import { domusoResponsiveStyleHelper } from "../../../screens/new/utils/domuso-responsive";
import Auryc from "rn-auryc-sdk";

export interface UploadPhotoViewProps {
  onPress: any;
  title: string;
  photo: string | null;
  isProcessing: boolean;
  disabled: boolean;
  testID: string;
  accessibilityLabel: string;
}

export const UploadPhotoView = (props: UploadPhotoViewProps) => {
  const { onPress, title, photo, isProcessing, disabled, testID, accessibilityLabel } = props;
  const styles = getStyles();
  const isMock = photo === CheckImageType.MOCK;
  let [imageWidth, setImageWidth] = useState(0);

  const renderImage = () => {
    if (isMock) {
      return (
        <View accessible={true} ref={(x) => Auryc.markViewAsSensitiveInformation(x)}>
          <Image
            source={require("./../../../../assets/mock-check.jpeg")}
            style={[styles.image, { width: imageWidth }]}
            resizeMode="stretch"
            borderRadius={5}
          />
        </View>
      );
    } else {
      return (
        <View accessible={true} ref={(x) => Auryc.markViewAsSensitiveInformation(x)}>
          <Image
            source={{ uri: photo }}
            style={[styles.image, { width: imageWidth }]}
            resizeMode="stretch"
            borderRadius={5}
          />
        </View>
      );
    }
  };
  const renderProcessingText = () => {
    return (
      <Text
        style={styles.takePhotoTopLabel}
        text={translate("paymentFlow.paymentMethodMobileCheckPay.processing.processing") as string}
        {...automationTestingLocators.paymentFlowPaymentMethodMobileCheckPayProcessing
          .processingLabel}
      />
    );
  };

  const textColor = disabled ? themeUiComponent.colors.mediumGrey : themeUiComponent.colors.primary;
  const iconColor = disabled ? themeUiComponent.colors.mediumGrey : themeUiComponent.colors.primary;
  const actionOnPress = disabled ? null : onPress;
  return (
    <View
      style={{ flex: 1 }}
      onLayout={(event) => {
        let { width } = event.nativeEvent.layout;
        setImageWidth(width - 5);
      }}>
      <Text
        style={styles.takePhotoTopLabel}
        {...automationTestingLocators.paymentFlowPaymentMethodMobileCheckPayProcessing
          .frontBackLabel}>
        {title}
      </Text>
      <TouchableOpacity
        style={[styles.container]}
        onPress={actionOnPress}
        disabled={disabled}
        activeOpacity={0.6}
        accessibilityLabel={accessibilityLabel}
        testID={testID}>
        <View>
          {isProcessing ? (
            renderProcessingText()
          ) : photo ? (
            renderImage()
          ) : (
            <>
              <View style={styles.iconContainer}>
                <Icon name={"camera"} size={themeUiComponent.iconSize.medium} color={iconColor} />
              </View>
              <View style={styles.titleContainer}>
                <Text style={[typography.title2, styles.titleText, { color: textColor }]}>
                  {"Take Photo"}
                </Text>
              </View>
            </>
          )}
        </View>
      </TouchableOpacity>
    </View>
  );
};

const getStyles = () => {
  const { width } = Dimensions.get("window");
  return StyleSheet.create({
    container: {
      width: "100%",
      borderColor: themeUiComponent.colors.mediumGrey,
      borderRadius: 10,
      borderWidth: 1,
      alignItems: "center",
      justifyContent: "center",
      outlineStyle: "none",
      alignContent: "center",
      ...domusoResponsiveStyleHelper({
        webPhone: { height: 100 },
        webTablet: { height: 120 },
        webDesktop: { height: 120 },
        iosPhone: { height: 100 },
        iosTablet: { height: 120 },
        androidPhone: { height: 100 },
        androidTablet: { height: 120 },
      }),
    },
    takePhotoTopLabel: {
      ...typography.subHeading,
      fontFamily: "Lato_400Regular",
      color: themeUiComponent.colors.text3,
      lineHeight: 30,
    },
    iconContainer: { alignItems: "center" },
    titleText: {
      fontSize: themeUiComponent.fontSize.title2,
      fontFamily: "Lato_400Regular",
      textAlign: "center",
    },
    titleContainer: { paddingTop: 8 },
    image: {
      borderRadius: 10,
      ...domusoResponsiveStyleHelper({
        webPhone: { height: 98 },
        webTablet: { height: 118 },
        webDesktop: { height: 118 },
        iosPhone: { height: 98 },
        iosTablet: { height: 118 },
        androidPhone: { height: 98 },
        androidTablet: { height: 118 },
      }),
    },
  });
};
